<h2 class="accessibility-only">Next Game</h2>
<fgb-game-card [game]="nextGame$ | async"></fgb-game-card>
